export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14492.e3e5ffe1.jpg";